/* NDC · Rediseño 2026-09 · Fase 2 · Página de producto (vanilla, defer).
   Módulos: barra sticky de compra (IntersectionObserver sobre el botón del formulario y el footer), cambio de variante
   (evento 'variant-change' de <variant-selection> de Flex → precio de la barra, chip de añada, cálculo del pack),
   dots de la galería (Flickity de Flex sin pageDots), acordeones de la descripción (dl.cc-accordion → botones),
   flechas del slider de relacionados (delegado: la sección se re-renderiza por AJAX), evento GA4 pack_progress_view.
   No usa jQuery salvo para pedir a Flickity que cambie de slide. */
(function () {
  'use strict';
  if (window.__ndcPdpInit) return;
  window.__ndcPdpInit = true;

  var track = function (payload) { try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {} };
  var mqDesktop = window.matchMedia('(min-width: 1100px)');

  function formatMoney(cents, format) {
    var fmt = format || (document.querySelector('[data-money-format]') || {}).getAttribute && document.querySelector('[data-money-format]').getAttribute('data-money-format') || 'S/. {{amount}}';
    var out;
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') out = window.Shopify.formatMoney(cents, fmt);
    } catch (e) {}
    if (!out) {
      var n = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      out = fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
    }
    return out.replace(/[.,]00(?=\s*$|<)/, '');
  }

  /* ---------- Barra sticky ---------- */
  var stickyObs = [];
  var stickyTrigger = null;
  function initSticky() {
    var bar = document.querySelector('[data-ndc-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var trigger = document.querySelector('.ndc-pdp .purchase-details__buttons') || document.querySelector('.ndc-pdp .product-form-container') || document.querySelector('.ndc-pdp .modal_price');
    if (!trigger) return;
    if (trigger === stickyTrigger && document.contains(trigger)) return; // ya observado
    stickyObs.forEach(function (o) { o.disconnect(); });
    stickyObs = [];
    stickyTrigger = trigger;
    var footer = document.querySelector('footer') || document.querySelector('[id*="__footer"]');
    var pastButton = false, atFooter = false;
    function update() {
      var show = pastButton && !atFooter;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('has-ndc-sticky', show);
      document.body.classList.toggle('ndc-sticky-visible', show);
    }
    var o1 = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      // "pasado" = el botón ha salido por arriba del viewport
      pastButton = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      update();
    }, { threshold: 0 });
    o1.observe(trigger);
    stickyObs.push(o1);
    if (footer) {
      var o2 = new IntersectionObserver(function (entries) { atFooter = entries[entries.length - 1].isIntersecting; update(); }, { threshold: 0 });
      o2.observe(footer);
      stickyObs.push(o2);
    }
    var addBtn = bar.querySelector('[data-ndc-sticky-add]');
    if (addBtn && !addBtn.getAttribute('data-ndc-bound')) {
      addBtn.setAttribute('data-ndc-bound', '1');
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var main = document.querySelector('.ndc-pdp .purchase-details__buttons [data-add-to-cart-trigger]');
        var form = document.querySelector('.ndc-pdp form[data-product-form], .ndc-pdp .shopify-product-form');
        var select = form && form.querySelector('select[name="id"]');
        var target = stickyTrigger || document.querySelector('.ndc-pdp .product-form-container');
        if (select && (select.value === 'not-selected' || !select.value)) {
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (main) {
          main.click();
          track({ event: 'sticky_add_to_cart', item_name: (bar.querySelector('.ndc-sticky__t b') || {}).textContent });
        } else if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  /* ---------- Cambio de variante ---------- */
  function initVariant() {
    var vs = document.querySelector('.ndc-pdp [data-variant-selection]');
    if (!vs) return;
    vs.addEventListener('variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      var product = e.detail && e.detail.product;
      var bar = document.querySelector('[data-ndc-sticky]');
      if (bar) {
        var price = bar.querySelector('[data-ndc-sticky-price]');
        var btn = bar.querySelector('[data-ndc-sticky-add]');
        var sub = bar.querySelector('[data-ndc-sticky-sub]');
        if (v) {
          if (price) price.textContent = formatMoney(v.price, bar.getAttribute('data-money-format'));
          if (btn) {
            btn.disabled = !v.available;
            btn.setAttribute('aria-disabled', String(!v.available));
            btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-label-soldout');
          }
          if (sub && !v.available) sub.textContent = btn ? btn.getAttribute('data-label-soldout') : '';
        }
      }
      // Chip de añada
      var chip = document.querySelector('[data-ndc-anada]');
      if (chip && v && product && product.options) {
        var idx = Number(chip.getAttribute('data-ndc-anada-index'));
        var opts = v.options || [];
        if (!isNaN(idx) && opts[idx]) chip.textContent = opts[idx];
      }
      // Cálculo del pack ×6
      var pack = document.querySelector('[data-ndc-pack6]');
      if (pack && v) {
        var qty = Number(pack.getAttribute('data-ndc-pack6-qty')) || 6;
        var pct = Number(pack.getAttribute('data-ndc-pack6-pct')) || 20;
        var full = v.price * qty;
        var fin = full - Math.floor(full * pct / 100);
        var el;
        if ((el = pack.querySelector('[data-ndc-pack6-unit]'))) el.textContent = formatMoney(v.price);
        if ((el = pack.querySelector('[data-ndc-pack6-full]'))) el.textContent = formatMoney(full);
        if ((el = pack.querySelector('[data-ndc-pack6-final]'))) el.textContent = formatMoney(fin);
        if ((el = pack.querySelector('[data-ndc-pack6-id]'))) el.value = v.id;
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        pack.hidden = !v.available || !!onSale;
      }
    });
  }

  /* ---------- Dots de la galería (móvil) ---------- */
  function initDots() {
    var dots = document.querySelector('[data-ndc-gdots]');
    var gallery = document.querySelector('.ndc-pdp .product-gallery__main');
    if (!dots || !gallery) return;
    var slides = gallery.querySelectorAll('.product-gallery__image');
    if (slides.length < 2) { dots.hidden = true; return; }
    dots.hidden = false;
    dots.innerHTML = '';
    var buttons = [];
    for (var i = 0; i < slides.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Imagen ' + (i + 1) + ' de ' + slides.length);
      b.setAttribute('data-index', String(i));
      dots.appendChild(b);
      buttons.push(b);
    }
    function sync() {
      var sel = 0;
      for (var j = 0; j < slides.length; j++) { if (slides[j].classList.contains('is-selected')) { sel = j; break; } }
      buttons.forEach(function (bt, k) { bt.classList.toggle('is-on', k === sel); bt.setAttribute('aria-current', k === sel ? 'true' : 'false'); });
    }
    sync();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      for (var s = 0; s < slides.length; s++) mo.observe(slides[s], { attributes: true, attributeFilter: ['class'] });
    }
    dots.addEventListener('click', function (e) {
      var bt = e.target.closest('button');
      if (!bt) return;
      var idx = Number(bt.getAttribute('data-index'));
      try {
        if (window.jQuery && window.jQuery(gallery).data('flickity')) { window.jQuery(gallery).flickity('select', idx); return; }
      } catch (err) {}
      try {
        var slider = gallery.querySelector('.flickity-slider');
        if (slider && slides[idx]) slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      } catch (err2) {}
    });
  }

  /* ---------- Acordeones ---------- */
  function initAccordion() {
    document.querySelectorAll('.ndc-acc dl').forEach(function (dl) {
      if (dl.getAttribute('data-ndc-acc-ready')) return;
      dl.setAttribute('data-ndc-acc-ready', 'true');
      var openFirst = dl.closest('.ndc-acc') && dl.closest('.ndc-acc').getAttribute('data-open-first') !== 'false';
      var dts = dl.querySelectorAll(':scope > dt');
      dts.forEach(function (dt, i) {
        var dd = dt.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        var label = dt.textContent.replace(/[◄►▼▲]/g, '').trim();
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ndc-acc__btn';
        var id = 'ndc-acc-' + i + '-' + Math.random().toString(36).slice(2, 7);
        dd.id = id;
        btn.setAttribute('aria-controls', id);
        var open = openFirst && i === 0;
        btn.setAttribute('aria-expanded', String(open));
        btn.innerHTML = '<span></span><svg class="ndc-i" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
        btn.firstChild.textContent = label;
        dt.innerHTML = '';
        dt.appendChild(btn);
        dd.hidden = !open;
        dd.setAttribute('aria-hidden', String(!open));
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!isOpen));
          dd.hidden = isOpen;
          dd.setAttribute('aria-hidden', String(isOpen));
        });
      });
    });
  }

  /* ---------- Slider de relacionados (delegado) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ndc-pslider-prev], [data-ndc-pslider-next]');
    if (!btn) return;
    var wrap = btn.closest('[data-ndc-pslider]');
    var trackEl = wrap && wrap.querySelector('[data-ndc-pslider-track]');
    if (!trackEl) return;
    var item = trackEl.querySelector('.ndc-pslider__item');
    var step = item ? item.getBoundingClientRect().width + 16 : trackEl.clientWidth * 0.8;
    var dir = btn.hasAttribute('data-ndc-pslider-next') ? 1 : -1;
    trackEl.scrollBy({ left: dir * step * (mqDesktop.matches ? 3 : 1), behavior: 'smooth' });
  });
  function syncArrows() {
    document.querySelectorAll('[data-ndc-pslider]').forEach(function (wrap) {
      var t = wrap.querySelector('[data-ndc-pslider-track]');
      var prev = wrap.querySelector('[data-ndc-pslider-prev]');
      var next = wrap.querySelector('[data-ndc-pslider-next]');
      if (!t || !prev || !next) return;
      var max = t.scrollWidth - t.clientWidth - 2;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft >= max;
    });
  }
  document.addEventListener('scroll', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ndc-pslider-track')) syncArrows(); }, true);
  window.addEventListener('resize', syncArrows);

  /* ---------- GA4: pack_progress_view (carrito y mini-cart) ---------- */
  var sentProgress = {};
  function trackProgress() {
    document.querySelectorAll('[data-ndc-pack-progress]').forEach(function (el) {
      var n = el.getAttribute('data-eligible');
      var key = n + ':' + (el.classList.contains('is-done') ? 'done' : 'missing');
      if (sentProgress[key]) return;
      sentProgress[key] = true;
      track({ event: 'pack_progress_view', eligible: Number(n), min: Number(el.getAttribute('data-min')) });
    });
  }

  /* ---------- Arranque + re-render de secciones AJAX (relacionados, mini-cart) ---------- */
  function boot() {
    initSticky();
    initVariant();
    initDots();
    initAccordion();
    syncArrows();
    trackProgress();
    if ('MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () { initSticky(); syncArrows(); trackProgress(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { initSticky(); initDots(); syncArrows(); });
  setTimeout(initSticky, 1500);
})();
